import Modal from '@components/App/Modal/Modal'
import NotificationWrapper from '@components/App/NotificationContainer/NotificationWrapper'
import SystemDialogs from '@components/App/SystemDialogs'
import { DashboardLayout, MembersList } from '@components/Dashboard'
import type React from 'react'

import { AuthenticatedWrapper } from './AuthenticatedWrapper'

export const DashboardMembers: React.FC = () => (
  <AuthenticatedWrapper>
    <NotificationWrapper />
    <DashboardLayout>
      <MembersList />
    </DashboardLayout>
    <SystemDialogs />
    <Modal />
  </AuthenticatedWrapper>
)
